export const paperSizes = [
  {
    size: {
      widthInMM: 841,
      heightInMM: 1189,
    },
    resolutions: [
      {
        widthInPX: 2384,
        heightInPX: 3370,
        ppi: 72,
      },
      {
        widthInPX: 3179,
        heightInPX: 4494,
        ppi: 96,
      },
      {
        widthInPX: 4967,
        heightInPX: 7022,
        ppi: 150,
      },
      {
        widthInPX: 9933,
        heightInPX: 14043,
        ppi: 300,
      },
      {
        widthInPX: 19866,
        heightInPX: 28087,
        ppi: 600,
      },
      {
        widthInPX: 23839,
        heightInPX: 33704,
        ppi: 720,
      },
      {
        widthInPX: 39732,
        heightInPX: 56173,
        ppi: 1200,
      },
      {
        widthInPX: 47679,
        heightInPX: 67408,
        ppi: 1440,
      },
      {
        widthInPX: 79464,
        heightInPX: 112346,
        ppi: 2400,
      },
      {
        widthInPX: 95357,
        heightInPX: 134816,
        ppi: 2880,
      },
    ],
    type: 'A',
    name: 'A0 Document',
    shortcut: 'A0',
    lowercaseName: 'a0',
  },
  {
    size: {
      widthInMM: 594,
      heightInMM: 841,
    },
    resolutions: [
      {
        widthInPX: 1684,
        heightInPX: 2384,
        ppi: 72,
      },
      {
        widthInPX: 2245,
        heightInPX: 3179,
        ppi: 96,
      },
      {
        widthInPX: 3508,
        heightInPX: 4967,
        ppi: 150,
      },
      {
        widthInPX: 7016,
        heightInPX: 9933,
        ppi: 300,
      },
      {
        widthInPX: 14043,
        heightInPX: 19866,
        ppi: 600,
      },
      {
        widthInPX: 16838,
        heightInPX: 23839,
        ppi: 720,
      },
      {
        widthInPX: 28066,
        heightInPX: 39732,
        ppi: 1200,
      },
      {
        widthInPX: 33676,
        heightInPX: 47679,
        ppi: 1440,
      },
      {
        widthInPX: 56131,
        heightInPX: 79464,
        ppi: 2400,
      },
      {
        widthInPX: 67351,
        heightInPX: 95357,
        ppi: 2880,
      },
    ],
    type: 'A',
    name: 'A1 Document',
    shortcut: 'A1',
    lowercaseName: 'a1',
  },
  {
    size: {
      widthInMM: 420,
      heightInMM: 594,
    },
    resolutions: [
      {
        widthInPX: 1191,
        heightInPX: 1684,
        ppi: 72,
      },
      {
        widthInPX: 1587,
        heightInPX: 2245,
        ppi: 96,
      },
      {
        widthInPX: 2480,
        heightInPX: 3508,
        ppi: 150,
      },
      {
        widthInPX: 4960,
        heightInPX: 7016,
        ppi: 300,
      },
      {
        widthInPX: 9933,
        heightInPX: 14043,
        ppi: 600,
      },
      {
        widthInPX: 11906,
        heightInPX: 16838,
        ppi: 720,
      },
      {
        widthInPX: 19842,
        heightInPX: 28066,
        ppi: 1200,
      },
      {
        widthInPX: 23811,
        heightInPX: 33676,
        ppi: 1440,
      },
      {
        widthInPX: 39684,
        heightInPX: 56131,
        ppi: 2400,
      },
      {
        widthInPX: 47622,
        heightInPX: 67351,
        ppi: 2880,
      },
    ],
    type: 'A',
    name: 'A2 Document',
    shortcut: 'A2',
    lowercaseName: 'a2',
  },
  {
    size: {
      widthInMM: 297,
      heightInMM: 420,
    },
    resolutions: [
      {
        widthInPX: 842,
        heightInPX: 1191,
        ppi: 72,
      },
      {
        widthInPX: 1123,
        heightInPX: 1587,
        ppi: 96,
      },
      {
        widthInPX: 1754,
        heightInPX: 2480,
        ppi: 150,
      },
      {
        widthInPX: 3508,
        heightInPX: 4960,
        ppi: 300,
      },
      {
        widthInPX: 7016,
        heightInPX: 9933,
        ppi: 600,
      },
      {
        widthInPX: 8419,
        heightInPX: 11906,
        ppi: 720,
      },
      {
        widthInPX: 14032,
        heightInPX: 19842,
        ppi: 1200,
      },
      {
        widthInPX: 16838,
        heightInPX: 23811,
        ppi: 1440,
      },
      {
        widthInPX: 28063,
        heightInPX: 39684,
        ppi: 2400,
      },
      {
        widthInPX: 33676,
        heightInPX: 47622,
        ppi: 2880,
      },
    ],
    type: 'A',
    name: 'A3 Document',
    shortcut: 'A3',
    lowercaseName: 'a3',
  },
  {
    size: {
      widthInMM: 210,
      heightInMM: 297,
    },
    resolutions: [
      {
        widthInPX: 595,
        heightInPX: 842,
        ppi: 72,
      },
      {
        widthInPX: 794,
        heightInPX: 1123,
        ppi: 96,
      },
      {
        widthInPX: 1240,
        heightInPX: 1754,
        ppi: 150,
      },
      {
        widthInPX: 2480,
        heightInPX: 3508,
        ppi: 300,
      },
      {
        widthInPX: 4960,
        heightInPX: 7016,
        ppi: 600,
      },
      {
        widthInPX: 5953,
        heightInPX: 8419,
        ppi: 720,
      },
      {
        widthInPX: 9921,
        heightInPX: 14032,
        ppi: 1200,
      },
      {
        widthInPX: 11906,
        heightInPX: 16838,
        ppi: 1440,
      },
      {
        widthInPX: 19843,
        heightInPX: 28063,
        ppi: 2400,
      },
      {
        widthInPX: 23811,
        heightInPX: 33676,
        ppi: 2880,
      },
    ],
    type: 'A',
    name: 'A4 Document',
    shortcut: 'A4',
    lowercaseName: 'a4',
  },
  {
    size: {
      widthInMM: 148,
      heightInMM: 210,
    },
    resolutions: [
      {
        widthInPX: 420,
        heightInPX: 595,
        ppi: 72,
      },
      {
        widthInPX: 559,
        heightInPX: 794,
        ppi: 96,
      },
      {
        widthInPX: 874,
        heightInPX: 1240,
        ppi: 150,
      },
      {
        widthInPX: 1748,
        heightInPX: 2480,
        ppi: 300,
      },
      {
        widthInPX: 3508,
        heightInPX: 4960,
        ppi: 600,
      },
      {
        widthInPX: 4195,
        heightInPX: 5953,
        ppi: 720,
      },
      {
        widthInPX: 6992,
        heightInPX: 9921,
        ppi: 1200,
      },
      {
        widthInPX: 8391,
        heightInPX: 11906,
        ppi: 1440,
      },
      {
        widthInPX: 13985,
        heightInPX: 19843,
        ppi: 2400,
      },
      {
        widthInPX: 16781,
        heightInPX: 23811,
        ppi: 2880,
      },
    ],
    type: 'A',
    name: 'A5 Document',
    shortcut: 'A5',
    lowercaseName: 'a5',
  },
  {
    size: {
      widthInMM: 105,
      heightInMM: 148,
    },
    resolutions: [
      {
        widthInPX: 298,
        heightInPX: 420,
        ppi: 72,
      },
      {
        widthInPX: 397,
        heightInPX: 559,
        ppi: 96,
      },
      {
        widthInPX: 620,
        heightInPX: 874,
        ppi: 150,
      },
      {
        widthInPX: 1240,
        heightInPX: 1748,
        ppi: 300,
      },
      {
        widthInPX: 2480,
        heightInPX: 3508,
        ppi: 600,
      },
      {
        widthInPX: 2976,
        heightInPX: 4195,
        ppi: 720,
      },
      {
        widthInPX: 4961,
        heightInPX: 6992,
        ppi: 1200,
      },
      {
        widthInPX: 5953,
        heightInPX: 8391,
        ppi: 1440,
      },
      {
        widthInPX: 9922,
        heightInPX: 13985,
        ppi: 2400,
      },
      {
        widthInPX: 11906,
        heightInPX: 16781,
        ppi: 2880,
      },
    ],
    type: 'A',
    name: 'A6 Document',
    shortcut: 'A6',
    lowercaseName: 'a6',
  },
  {
    size: {
      widthInMM: 216,
      heightInMM: 279,
      widthInPX: 816,
      heightInPX: 1056,
    },
    type: 'us-letter',
    name: 'US Letter Document',
    shortcut: 'us-letter',
    lowercaseName: 'us-letter',
  },
  {
    size: {
      widthInMM: 216,
      heightInMM: 356,
      widthInPX: 816,
      heightInPX: 1344,
    },
    type: 'us-legal',
    name: 'US Legal Document',
    shortcut: 'us-legal',
    lowercaseName: 'us-legal',
  },
];
